import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "react-toastify";

export default function Delaysidebar({
  isOpen,
  doctordata,
  onClose,
  handleConfirmDelay,
  selectedHour,
  setSelectedHour,
  selectedMinute,
  setSelectedMinute,
  dayofweek,
  setDayofweek,
  fromTime,
  setFromTime,
  toTime,
  setToTime,
}) {
  const API_URL = process.env.REACT_APP_API_URL;
  const [doctorlist, setDoctorlist] = useState([]);
  useEffect(() => {
    fetchdoctordata();
  }, []);
  const fetchdoctordata = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const today = new Date();
    const formattedDate = format(today, "yyyy-MM-dd");
       const clinicId = localStorage.getItem("clinicId");
    try {
      const response = await axios.get(
        `${API_URL}doctor/doctorSlotlist?clinicId=${clinicId}&doctorCode=${doctordata.doctorCode}&whenAppointment=${formattedDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
            },
        }
      );
      console.log(response.data, "esdrtfyguijokp");
      setDoctorlist(response.data);
      if (response.data.length > 0) {
        setDayofweek(response.data[0].dayOfWeek);
      }
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  };
  console.log(doctorlist, "doctorlist");
  return (
    <div className="fixed top-0 right-0 z-50 h-full w-full max-w-md bg-white shadow-lg border-l border-gray-200 p-6 overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-[#004276]">
          Change Availability
        </h2>
        <button onClick={onClose}>
          <X className="w-5 h-5 text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      {/* Form */}
      <div className="space-y-5">
        <div>
          <label className="text-sm font-medium text-gray-600">
            Select Time Slot
          </label>
          <select
            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
            onChange={(e) => {
              const [start, end] = e.target.value.split("-");
              setFromTime(start.trim());
              setToTime(end.trim());
            }}
          >
            <option value="">-- Select Time Slot --</option>
            {doctorlist.map((slot, index) => (
              <option key={index} value={`${slot.startTime}-${slot.endTime}`}>
                {slot.startTime} - {slot.endTime}
              </option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-medium text-yellow-800 mb-2">
              Hour
            </label>
            <select
              className="border w-full border-gray-300 rounded-lg px-3 py-2 bg-white"
              value={selectedHour}
              onChange={(e) => setSelectedHour(parseInt(e.target.value))}
            >
              {[...Array(6)].map((_, i) => (
                <option key={i} value={i}>
                  {i} hr
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-yellow-800 mb-2">
              Minute
            </label>
            <select
              className="border w-full border-gray-300 rounded-lg px-3 py-2 bg-white"
              value={selectedMinute}
              onChange={(e) => setSelectedMinute(parseInt(e.target.value))}
            >
              {[0, 10, 15, 20, 30, 45].map((min) => (
                <option key={min} value={min}>
                  {min} min
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex justify-between items-center mt-6">
          {/* <button
            onClick={onClose}
            className="px-6 py-2 border border-[#004276] text-[#004276] rounded-full text-sm"
          >
            Cancel Appointment
          </button> */}
          <button
            className="px-6 py-2 bg-[#004276] text-white rounded-full text-sm"
            onClick={handleConfirmDelay}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
